import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'

const JsonLD = ({data}) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        ...data
      })}
    </script>
  </Helmet>
)

JsonLD.propTypes = {
  data: PropTypes.object.isRequired
}

export default JsonLD
